import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { CompanyService } from '../../../services/company.service';
import { NtCompany } from '../models/nt-company';

@Directive({
  selector: '[appCompanyDynFieldHeader]'
})
export class CompanyDynFieldHeaderDirective implements OnInit {
    @Input('fieldName') field = 'class';
    
    constructor(private comp: CompanyService,
        private eRef: ElementRef) { }

    ngOnInit(): void {
        this.comp.SelectedCompany.pipe(take(1))
            .subscribe(comp => {
                if(!comp){
                    return;
                }

                let textResult = '';
                const field = this.field.toLowerCase();
                if(field === 'class'){
                    textResult = NtCompany.GetProviderClassColName(comp.externalDataSource.dataSource);
                }else{
                    textResult = NtCompany.GetProviderLocationColName(comp.externalDataSource.dataSource, comp.useProviderLocation);
                }
                console.log('company-dyn-field-header directive is setting innerText to', textResult);
                this.eRef.nativeElement.innerText = textResult;
            }
        );
    }

}
